import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";
import { showPreviewPermissionsDrawer } from "components/PreviewPermissions";

import { showUnassignConfirmation } from "../../UnassignConfirmation";
import { ApiKeyViewRoleBinding } from "../../types";
import { SettingsContext } from "../../../Context";

type ApiKeyRolesListItemActionsDropdownCellProps = {
  roleBinding: ApiKeyViewRoleBinding;
  isLastRole?: boolean;
};

const ApiKeyRolesListItemActionsDropdownCell = ({
  roleBinding,
  isLastRole = false,
}: ApiKeyRolesListItemActionsDropdownCellProps) => {
  const { activationStatus } = useTypedContext(SettingsContext);
  const handlePreviewPermissions = () => {
    showPreviewPermissionsDrawer({ roleId: roleBinding.role.id });
  };

  const handleDelete = () => {
    showUnassignConfirmation({
      id: roleBinding.id,
      name: roleBinding.role.name,
      refetchQueries: ["GetApiKey"],
      isLastRole,
      activationStatus,
    });
  };

  return (
    <DropdownMenuEllipsis tooltip="Role actions">
      <DropdownMenuItem onAction={handlePreviewPermissions}>Preview permissions</DropdownMenuItem>
      <DropdownMenuItem danger onAction={handleDelete}>
        Unassign
      </DropdownMenuItem>
    </DropdownMenuEllipsis>
  );
};

export default ApiKeyRolesListItemActionsDropdownCell;
